<template>
  <v-container
    class="bg-white"
    width="60%">
    <v-card
      class="pa-5"
      variant="text">
      <v-card-item>
        <v-card-title>Zusammenfassung</v-card-title>
        <template #append>
          <v-fab
            elevation="0"
            icon="mdi-close"
            @click.prevent="$emit('close')"></v-fab>
        </template>
      </v-card-item>

      <v-card-text>
        <p>
          {{
            $t(
              "views.licence.review." +
                (reviewData.yearly ? "yearlyCosts" : "monthlyCosts"),
              { costs: reviewData.newCosts }
            )
          }}
        </p>
        <template v-if="removed && reviewData.switchYearly">
         {{ $t("views.licence.review.switchYearModuleRemove", {date: (new Date(reviewData.date * 1000)).toLocaleDateString()}) }}
        </template>
        <p v-if="chargeNeeded > 0">
            <!-- <template v-if="reviewData.switchYearly && removed">
{{ $t("views.licence.review.additionalCostsSwitchYear") }}
            </template> -->
            <template v-if="reviewData.switchYearly && !removed">
              {{ $t("views.licence.review.additionalCostsSwitchYear") }}
            </template>
            <template v-else>
              {{
                $t(
                  "views.licence.review.additionalCosts" +
                    ((reviewData.yearly && reviewData.switchYearly && !removed) || reviewData.switchMonthly ? "Year" : ""),
                  {
                    remainingDays: reviewData.remainingDays
                  }
                )
              }}
            </template>
            <template v-if="reviewData.additionalPrice">
              {{ reviewData.additionalPrice }}
            </template>
            <v-progress-circular
              :size="15"
              v-else
              indeterminate />
        </p>

        <v-data-table
          :headers="headers"
          :items="items"
          hide-default-footer></v-data-table>

        <p v-if="removed">
          <template v-if="private">
            {{
              $t("views.licence.review.module-removed", {
                date: (new Date(reviewData.date * 1000)).toLocaleDateString()
              })
            }}
          </template>
          <template v-else>
            Entfernte Module können ohne Aufpreis noch bis zum Ende der
            Zahlungsperiode anderen Teammitgliedern zugewiesen werden.
          </template>
        </p>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          elevation="3"
          @click="emits('close')">
          Abbrechen
        </v-btn>
        <v-btn
          elevation="3"
          data-cy="licence-popup-save"
          @click="emits('save')"
          >Speichern</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script lang="ts" setup>
import { listModule } from "@/types/global";
import { useTranslation } from "i18next-vue";
import { computed } from "vue";

const { t } = useTranslation();
const emits = defineEmits(["close", "save"]);

const props = defineProps({
  private: {
    type: Boolean,
    required: false
  },
  reviewData: {
    type: Object,
    required: true
  },
  modulesRemoved: {
    type: Object,
    required: true
  },
  initialItems: {
    type: Array,
    required: true
  },
  items: {
    type: Array,
    required: true
  },
  chargeNeeded: {
    type: Number,
    required: true
  }
});

const headers = [
  { title: "Modul", key: "module" },
  { title: "Alte Anzahl", key: "oldQuantity" },
  { title: "Neue Anzahl", key: "newQuantity" }
];

const items = computed(() => {
  return props.initialItems.map((item: listModule, index) => {
    return {
      module: t("views.licence.modules." + item.name + ".name"),
      oldQuantity: item.slots,
      newQuantity: props.items[index]?.slots
    };
  });
});

const removed = computed(() => {
  return Object.values(props.modulesRemoved).filter((item) => item > 0).length;
});
</script>
